import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as alertsActions from './alertsActions';
import * as alertsSelectors from './alertsSelectors';

const { qcsSyncGetResources, qcsSyncUpdateResource, qcsSyncDeleteResource, qcsSyncUpdateResources } = resourceSagaUtils;
const { getLastSyncDate } = alertsSelectors;

const mkResourceConfig = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'alerts',
    resourceBaseUrl: '/alert/alerts',
    getLastSyncDate,
    ...props,
  });

function* getAlertsActionWatcher() {
  const config = mkResourceConfig({
    successAction: alertsActions.getAlertsSuccess,
    failureAction: alertsActions.getAlertsFailure,
  });
  yield takeEvery(alertsActions.getAlerts, qcsSyncGetResources, config);
}

function* updateAlertActionWatcher() {
  const config = mkResourceConfig({
    successAction: alertsActions.updateAlertSuccess,
    failureAction: alertsActions.updateAlertFailure,
  });
  yield takeEvery(alertsActions.updateAlert, qcsSyncUpdateResource, config);
}

function* deleteAlertActionWatcher() {
  const config = mkResourceConfig({
    successAction: alertsActions.deleteAlertSuccess,
    failureAction: alertsActions.deleteAlertFailure,
  });
  yield takeEvery(alertsActions.deleteAlert, qcsSyncDeleteResource, config);
}

function* batchAlertsActionWatcher() {
  const config = mkResourceConfig({
    successAction: alertsActions.batchAlertsSuccess,
    failureAction: alertsActions.batchAlertsFailure,
  });
  yield takeEvery(alertsActions.batchAlerts, qcsSyncUpdateResources, config);
}

export default [getAlertsActionWatcher, updateAlertActionWatcher, deleteAlertActionWatcher, batchAlertsActionWatcher];
